import { FC } from "react";
import { WalletTableDataType } from "./Types";
import StatusIndicator from "../../StatusIndicator/StatusIndicator";
import { formatCurrency } from "../../../helper/helper";

interface MobileWalletCardProps {
  data: WalletTableDataType
  onClick: () => void;
}

export const MobileWalletCard: FC<MobileWalletCardProps> = ({ data, onClick }) => {
  return (
    <div
      key={data.id}
      className="mb-3 hover:shadow-md cursor-pointer transition-all"
      onClick={onClick}
    >
      {/* Date Header */}
      <div className="text-sm text-foreground-tertiary mb-3">
        {data.date}
      </div>

      {/* Invoice & RRR */}
      <div className="mb-3 space-y-1">
        <p className="text-sm text-foreground-tertiary">
          Invoice: <span className="text-foreground">{data.invoiceNumber}</span>
        </p>
        <p className="text-sm text-foreground-tertiary">
          RRR: <span className="text-foreground">{data.rrr}</span>
        </p>
      </div>

      {/* Customer Info */}
      <div className="mb-2">
        <p className="text-foreground font-medium">{data.customerName}</p>
        <p className="text-sm text-foreground-tertiary">{data.time}</p>
      </div>

      {/* Amount and Status */}
      <div className="flex items-center justify-between mt-3">
        <p className="text-lg font-semibold text-foreground">
          {formatCurrency(data.amount)}
        </p>
        <StatusIndicator incomingStatus={data.status as number} />
      </div>
    </div>
  );
};


